import { defineStore } from 'pinia';
/**
 * 移动端配置
 */
export const useH5Config = defineStore('h5Config', {
    state: (): H5ConfigState => ({
        statusBarHeight: 0,
    }),
    actions: {
        setStatusBarHeight(height: number) {
            this.statusBarHeight = height;
        },
    },
});
